import { type FamilySettings } from "../../common/js/webshop-product-utility";

const families : FamilySettings[] = [
    {
        "id": "suite",
        "title": "Boris FX Suite",
        "slug": "boris-fx-suite",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1711649096/Marketing/Website2024/Icons_SVG/BorisFXSuite2023/DarkBkg/Boris_FX_Suite_icons_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1732293813/Marketing/Current%20logos%20%28use%20these%29/PNG/BorisFXSuite2023/LightBkg/BorisFXSuite2024_Icon_LightBkg.png",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697589170/Marketing/Website2024/Icons_SVG/BorisFXSuite2023/LightBkg/BorisFXSuite2024_Horizontal_LightBkg.svg",
        "brandColorHex": "00AAED",
        "boxWidth": "202px",
        "defaults": {
            "host": "Multi-host",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Multi-host",
                "description": "The Complete Creative Toolkit",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/FinalCutPro_4K.png"
                ]
            }
        ]
    },
    {
        "id": "saph",
        "title": "Sapphire",
        "slug": "sapphire",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125276/Marketing/Website2024/Icons_SVG/Sapphire2023/DarkBkg/Sapphire2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125279/Marketing/Website2024/Icons_SVG/Sapphire2023/LightBkg/Sapphire2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125277/Marketing/Website2024/Icons_SVG/Sapphire2023/LightBkg/Sapphire2023_Horizontal_LightBkg.svg",
        "brandColorHex": "EB148D",
        "boxWidth": "104px",
        "defaults": {
            "host": "Adobe/OFX",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Adobe/OFX",
                "description": "Adobe and OFX Hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Davinci_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Nuke_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png",
                    "/svgs/host-icons/sapphire-adobe-ofx.svg",
                    "/svgs/host-icons/sapphire-multi-host.svg",
                ]
            },
            {
                "name": "Avid",
                "description": "Avid Media Composer",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png"
                ]
            },
            {
                "name": "Multi-Host",
                "description": "All Supported Hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Davinci_4K.png",
                    "/svgs/host-icons/sapphire-multi-host.svg",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Nuke_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png",
                    "/svgs/host-icons/sapphire-adobe-ofx.svg",
                ]
            }
        ]
    },
    {
        "id": "continuum",
        "title": "Continuum",
        "slug": "continuum",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125273/Marketing/Website2024/Icons_SVG/Continuum2023/DarkBkg/Continuum2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125275/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125274/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Horizontal_LightBkg.svg",
        "brandColorHex": "00AAED",
        "boxWidth": "116px",
        "defaults": {
            "host": "Adobe",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Adobe",
                "description": "Adobe After Effects & Premiere Pro",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png"
                ]
            },
            {
                "name": "Apple",
                "description": "Apple Final Cut Pro",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/FinalCutPro_4K.png"
                ]
            },
            {
                "name": "Avid",
                "description": "Avid Media Composer",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png"
                ]
            },
            {
                "name": "OFX",
                "description": "DaVinci Resolve, VEGAS Pro, and other OFX hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Davinci_4K.png",
                    "/svgs/host-icons/sapphire-multi-host.svg",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png"
                ]
            },
            {
                "name": "Multi-Host + Avid",
                "description": "All Supported Hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/FinalCutPro_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png"
                ]
            }
        ]
    },
    {
        "id": "continuum-fcp",
        "title": "Continuum FCP",
        "slug": "continuum-fcp",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125273/Marketing/Website2024/Icons_SVG/Continuum2023/DarkBkg/Continuum2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125275/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Icon_LightBkg.svg",
        "brandColorHex": "",
        "defaults": {
            "host": "Apple",
            "type": "subscription",
            "subscriptionType": "annual"
        }
    },
    {
        "id": "pi",
        "title": "Particle Illusion Pro",
        "slug": "particle-illusion-pro",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125281/Marketing/Website2024/Icons_SVG/ParticleIllusion2023/DarkBkg/ParticleIllusion2023__Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125283/Marketing/Website2024/Icons_SVG/ParticleIllusion2023/LightBkg/ParticleIllusion2023__Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1732215687/Marketing/Current%20logos%20%28use%20these%29/SVG/ParticleIllusion2023/LightBkg/ParticleIllusion2023_Horizontal_LightBkg.svg",
        "brandColorHex": "7f63a5",        
        "boxWidth": "155px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standalone Application",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/ParticleIllusion_Circle_4K.png"
                ]
            }
        ]
    },
    {
        "id": "moc",
        "title": "Mocha Pro",
        "slug": "mocha-pro",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125292/Marketing/Website2024/Icons_SVG/MochaPro2023/DarkBkg/MochaPro2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125294/Marketing/Website2024/Icons_SVG/MochaPro2023/LightBkg/MochaPro2023_Icon_LightBkg.svg",
        "bannerLight": "	https://borisfx-com-res.cloudinary.com/image/upload/v1697125295/Marketing/Website2024/Icons_SVG/MochaPro2023/LightBkg/MochaPro2023_Horizontal_LightBkg.svg",
        "brandColorHex": "DB641E",
        "boxWidth": "110px",
        "defaults": {
            "host": "Adobe",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Adobe",
                "description": "Adobe After Effects & Premiere Pro",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png"
                ]
            },
            {
                "name": "Avid",
                "description": "Avid Media Composer",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png"
                ]
            },
            {
                "name": "OFX",
                "description": "Nuke, Fusion, VEGAS Pro, and other OFX hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Nuke_4K.png",
                    "/svgs/host-icons/sapphire-multi-host.svg",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png"
                ]
            },
            {
                "name": "Multi-Host",
                "description": "All Supported Plugin Hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png",
                    "/svgs/host-icons/sapphire-multi-host.svg"
                ]
            },
            {
                "name": "Standalone + Plug-Ins",
                "description": "Standalone Application + Multi-host Plugins",
                "icons": [
                    "/svgs/host-icons/mocha.svg",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AvidMediaComposer_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png",
                    "/svgs/host-icons/sapphire-multi-host.svg"
                ]
            }
        ]
    },
    {
        "id": "cpop",
        "title": "CrumplePop",
        "slug": "crumplepop",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125296/Marketing/Website2024/Icons_SVG/CrumplePop2023/DarkBkg/Crumplepop2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125297/Marketing/Website2024/Icons_SVG/CrumplePop2023/LightBkg/Crumplepop2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125298/Marketing/Website2024/Icons_SVG/CrumplePop2023/LightBkg/Crumplepop2023_Horizontal_LightBkg.svg",
        "brandColorHex": "48CF7C",
        "boxWidth": "127px",
        "defaults": {
            "host": "Multi-host",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Multi-Host",
                "description": "All Supported Hosts",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973342/host%20icons/host_icon.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973395/host%20icons/host_icon2.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973445/host%20icons/premiere.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973487/host%20icons/host_icon3.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973525/host%20icons/host_icon4.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973574/host%20icons/fcp.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973770/host%20icons/vst3.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973807/host%20icons/au.svg"
                ]
            },
            {
                "name": "VST3",
                "description": "Single Host VST3",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973445/host%20icons/premiere.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973487/host%20icons/host_icon3.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973525/host%20icons/host_icon4.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973919/host%20icons/audacity.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973991/host%20icons/samplitude.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973770/host%20icons/vst3.svg"
                ]
            },
            {
                "name": "AU",
                "description": "Single Host AU",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973574/host%20icons/fcp.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774974078/host%20icons/host_icon6.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774974117/host%20icons/host_icon7.svg",
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1774973807/host%20icons/au.svg"
                ]
            }
        ]
    },
    {
        "id": "opt",
        "title": "Optics",
        "slug": "optics",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125289/Marketing/Website2024/Icons_SVG/Optics2023/DarkBkg/Optics2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125291/Marketing/Website2024/Icons_SVG/Optics2023/LightBkg/Optics2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125290/Marketing/Website2024/Icons_SVG/Optics2023/LightBkg/Optics2023_Horizontal_LightBkg.svg",
        "brandColorHex": "F2C663",
        "boxWidth": "104px",
        "defaults": {
            "host": "Standalone + Plug-Ins",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone + Plug-Ins",
                "description": "Standalone Application + Photoshop & Lightroom plugin",
                "icons": []
            }
        ]
    },
    {
        "id": "sil",
        "title": "Silhouette",
        "slug": "silhouette",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125286/Marketing/Website2024/Icons_SVG/Silhouette2023/DarkBkg/Silhouette2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125286/Marketing/Website2024/Icons_SVG/Silhouette2023/LightBkg/Silhouette2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125286/Marketing/Website2024/Icons_SVG/Silhouette2023/LightBkg/Silhouette2023_Horizontal_LightBkg.svg",
        "brandColorHex": "7F7F7F",
        "boxWidth": "113px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Adobe/OFX",
                "description": "Adobe and OFX Hosts",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/AfterEffects_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Davinci_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Nuke_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png"
                ]
            },
            {
                "name": "Standalone",
                "description": "Standalone Application + Multi-host Plugins",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/ProTools_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/PremierePro_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Davinci_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/Nuke_4K.png",
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/OFX_4K.png"
                ]
            }
        ]
    },
    {
        "id": "synth",
        "title": "SynthEyes",
        "slug": "syntheyes",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125308/Marketing/Website2024/Icons_SVG/SynthEyes2023/DarkBkg/SynthEyes2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125310/Marketing/Website2024/Icons_SVG/SynthEyes2023/LightBkg/SynthEyes2023_Icon_LightBkg.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125308/Marketing/Website2024/Icons_SVG/SynthEyes2023/LightBkg/SynthEyes2023_Horizontal_LightBkg.svg",
        "brandColorHex": "EA152F",
        "boxWidth": "115px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standalone Application",
                "icons": [
                    "https://cdn.borisfx.com/borisfx/store/suitemanager/icons/4K/HostProducts/SynthEyes_Circle_4K.png"
                ]
            }
        ]
    },
    {
        "id": "seq",
        "title": "Sequoia",
        "slug": "sequoia",
        "squareLogoDark": "",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1754872839/Marketing/Current%20logos%20%28use%20these%29/SVG/Sequoia2025/LightBkg/Sequoia_1.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1755199232/Marketing/Current%20logos%20%28use%20these%29/SVG/ProAudio%28Fixed%29/Sequoia2025_Horizontal_LightBkg-cropped.svg",
        "brandColorHex": "88F290",
        "boxWidth": "115px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standalone Application",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1754872839/Marketing/Current%20logos%20%28use%20these%29/SVG/Sequoia2025/LightBkg/Sequoia_1.svg"
                ]
            }
        ]
    },
    {
        "id": "samp",
        "title": "Samplitude",
        "slug": "samplitude",
        "squareLogoDark": "",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1754872825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude_1.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1754873825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude2025_Horizontal_LightBkg_4d54b58e-3d7f-48d8-8e16-d9134fedee2e_1_1.svg",
        "brandColorHex": "0085FF",
        "boxWidth": "115px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Samplitude - Standalone Application",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1754872825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude_1.svg"
                ]
            },
            {
                "name": "Standalone-suite",
                "description": "Samplitude Suite - Standalone Application + Extra Content",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1754872825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude_1.svg"
                ]
            }
        ]
    },
    {
        "id": "sampsuite",
        "title": "Samplitude Suite",
        "slug": "samplitude-suite",
        "squareLogoDark": "",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1754872825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude_1.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1755199231/Marketing/Current%20logos%20%28use%20these%29/SVG/ProAudio%28Fixed%29/SamplitudeSuite2025_Horizontal_LightBkg-cropped.svg",
        "brandColorHex": "0085FF",
        "boxWidth": "115px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standalone Application",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1754872825/Marketing/Current%20logos%20%28use%20these%29/SVG/Sampitude2025/LightBkg/Samplitude_1.svg"
                ]
            }
        ]
    },
    {
        "id": "musicstudio",
        "title": "Music Studio",
        "slug": "music-studio",
        "squareLogoDark": "",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1754872791/Marketing/Current%20logos%20%28use%20these%29/SVG/MusicStudio2025/LightBkg/MusicStudio_1.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1755199232/Marketing/Current%20logos%20%28use%20these%29/SVG/ProAudio%28Fixed%29/MusicStudio2025_Horizontal_LightBkg-cropped.svg",
        "brandColorHex": "FFA931",
        "boxWidth": "115px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standalone Application",
                "icons": []
            }
        ]
    },
    {
        "id": "unit",
        "title": "Continuum Units",
        "slug": "continuum-units",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125273/Marketing/Website2024/Icons_SVG/Continuum2023/DarkBkg/Continuum2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125275/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Icon_LightBkg.svg",
        "brandColorHex": "",
        "defaults": {
            "subfamily": "Continuum Units - Warp",
            "host": "Multi-host",
            "type": "perpetual"
        }
    },
    {
        "id": "fcp-unit",
        "title": "Continuum FCP Units",
        "slug": "continuum-fcp-units",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125273/Marketing/Website2024/Icons_SVG/Continuum2023/DarkBkg/Continuum2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125275/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Icon_LightBkg.svg",
        "brandColorHex": "",
        "defaults": {
            "subfamily": "Stylize Unit",
            "host": "Multi-host",
            "type": "perpetual"
        }
    },
    {
        "id": "filter",
        "title": "Continuum Premium Filters",
        "slug": "continuum-premium-filters",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125273/Marketing/Website2024/Icons_SVG/Continuum2023/DarkBkg/Continuum2023_Icon_DarkBkg.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1697125275/Marketing/Website2024/Icons_SVG/Continuum2023/LightBkg/Continuum2023_Icon_LightBkg.svg",
        "brandColorHex": "",
        "defaults": {
            "subfamily": "Continuum Filter - Lights",
            "host": "Multi-host",
            "type": "perpetual"
        }
    },
    {
        "id": "training",
        "title": "Training Products",
        "slug": "training-products",
        "squareLogoDark": "",
        "squareLogoLight": "",
        "brandColorHex": "",
        "defaults": {
            "subfamily": "Sapphire Essentials",
            "host": "Misc",
            "type": "Training"
        }
    },
    {
        "id": "presets",
        "title": "Presets and Templates",
        "slug": "presets-and-templates",
        "squareLogoDark": "",
        "squareLogoLight": "",
        "brandColorHex": "",
        "defaults": {
            "subfamily": "Sapphire Nitro FX, V1",
            "host": "Avid",
            "type": "perpetual"
        }
    },
    {
        "id": "vegas",
        "title": "Vegas Pro",
        "slug": "vegas-pro",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150869/Marketing/2026%20Logos/VegasPro/Horizontal/Light/SVG/VegasPro_Horizontal.svg",
        "brandColorHex": "248ee5",
        "boxWidth": "104px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Vegas Pro: Everything you need for professional video and audio editing.",
                "icons": [
                ]
            },
            {
                "name": "Standalone-plus",
                "description": "Vegas Pro Plus: More creative control with tracking, audio tools, and VFX.",
                "icons": [
                ]
            },
            {
                "name": "Standalone-ultimate",
                "description": "Vegas Pro Ultimate: The complete production suite for creators who want it all.",
                "icons": [
                ]
            }
        ]
    },
    {
        "id": "vegasplus",
        "title": "Vegas Pro Plus",
        "slug": "vegas-pro-plus",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150869/Marketing/2026%20Logos/VegasPro/Horizontal/Light/SVG/VegasPro_Horizontal.svg",
        "brandColorHex": "248ee5",
        "boxWidth": "104px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standlone Application",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
                ]
            }
        ]
    },
    {
        "id": "vegasult",
        "title": "Vegas Pro Ultimate",
        "slug": "vegas-pro-ultimate",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150869/Marketing/2026%20Logos/VegasPro/Horizontal/Light/SVG/VegasPro_Horizontal.svg",
        "brandColorHex": "248ee5",
        "boxWidth": "104px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Standlone Application",
                "icons": [
                    "https://borisfx-com-res.cloudinary.com/image/upload/v1772150897/Marketing/2026%20Logos/VegasPro/Icon/SVG/VegasPro.svg",
                ]
            }
        ]
    },
    {
        "id": "soundforge",
        "title": "Sound Forge",
        "slug": "sound-forge",
        "squareLogoDark": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150851/Marketing/2026%20Logos/SoundForge/Icon/SVG/SoundForge.svg",
        "squareLogoLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150851/Marketing/2026%20Logos/SoundForge/Icon/SVG/SoundForge.svg",
        "bannerLight": "https://borisfx-com-res.cloudinary.com/image/upload/v1772150827/Marketing/2026%20Logos/SoundForge/Horizontal/Light/SVG/SoundForge_Horizontal.svg",
        "brandColorHex": "e65554",
        "boxWidth": "104px",
        "defaults": {
            "host": "Standalone",
            "type": "subscription",
            "subscriptionType": "annual"
        },
        "hosts": [
            {
                "name": "Standalone",
                "description": "Sound Forge",
                "icons": [
                ]
            },
            {
                "name": "Standalone-plus",
                "description": "Sound Forge Plus",
                "icons": [
                ]
            }
        ]
    },
];

export default families;

